import { createVuetify } from 'vuetify'
import defaults from './defaults'
import { icons } from './icons'
import theme from './theme'
import { VDataTable, VDataTableFooter } from 'vuetify/labs/VDataTable'
// Styles
import '@core/scss/template/libs/vuetify/index.scss'
import 'vuetify/styles'

export default createVuetify({
  components: {
    VDataTable,
    VDataTableFooter
  },
  defaults,
  icons,
  theme,
})
